<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}} <span v-if="item">({{ item.object_count || 0}} objekter)</span></h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
        <a v-if="edit" href="javascript:;" @click="handleDeleteSubmit()" class="button primary" :class="{'disabled': item.object_count}">Slett</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
        <a v-if="edit" href="javascript:;" class="button primary disabled">Slett</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary disabled">Lagre<span class="show-for-medium"> endringer</span></a>
        <a v-if="edit" href="javascript:;" class="button primary disabled">Slett</a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-4" label="Lokasjonid" v-model.trim="item.Lokasjonid" :disabled="true"/>
              <TheTextInput containerClassName="cell large-4" label="Lokasjonkode" name="Lokasjonkode" v-model.trim="item.Lokasjonkode" maxlength="20" required v-validate="'required|max:20'"/>
              <TheSelectInput containerClassName="cell large-4" label="Avdeling" name="Avdeling" v-model.trim="item.Avdeling" :items="avdelingOptions"/>
              <TheTextInput containerClassName="cell large-12" label="Beskrivelse" name="Beskrivelse" v-model.trim="item.Beskrivelse" maxlength="200" v-validate="'max:200'"/>
              <TheSwitchInput containerClassName="cell large-6" label="Storagefee" v-model="item.Storagefee" labelTrue="Storagefee" labelFalse="Ikke Storagefee" trueValue="T" falseValue="F"/>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'

export default {
  name: 'InstillingerLokasjonEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      service: InstillingerService(this.servicename),
      edit: false,
      item: {},
      avdelingOptions: [
        {key: 'B', val: 'B'},
        {key: 'N', val: 'N'},
        {key: 'S', val: 'S'}
      ],
      loading: true
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  methods: {
    fetch: function () {
      if (!this.edit) {
        this.item.Avdeling = 'B'

        this.setFormLoading(false)
      } else {
        this.service.view(this.$route.params.id)
          .then((response) => {
            this.item = response.data
          })
          .catch(() => {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn lokasjonen')

            this.onCancel()
          })
          .then(() => {
            this.setFormLoading(false)
          })
      }
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            this.item.Lokasjonkode = this._.toUpper(this.item.Lokasjonkode)

            this.service.save(this.item.Lokasjonid, this.item)
              .then((response) => {
                this.$helpers.showSuccessAlert('Lokasjon er lagret')

                this.item = response.data

                if (!this.edit) {
                  this.$router.go(-1)
                }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    handleDeleteSubmit: function () {
      if (this.item.object_count) {
        return
      }

      var vm = this

      this.openConfirm(
        'Slett lokasjon',
        'Er du sikker på at du ønsker å slette denne lokasjonen? <br/> Du kan ikke angre denne handlingen.',
        'Ja',
        'Nei',
        function () {
          vm.service.delete(vm.item.Lokasjonid)
            .then((response) => {
              vm.closeModal()
              vm.onCancel()
              vm.$helpers.showSuccessAlert('Ok', 'Lokasjonen har blitt slettet')
            })
            .catch(() => {
              vm.$helpers.showErrorAlert('Feil', 'Kunne ikke slette lokasjonen')
              vm.closeModal()
            })
        },
        function () {
          console.log('NEI')
          vm.closeModal()
        }
      )
    },
    onCancel: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
input[name="Lokasjonkode"] {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerLokasjonEdit.vue